module.exports = __webpack_public_path__ + "static/media/PCWorkshopeDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.d33db75e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquitetura_neg/PCWorkshopeDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.png
// module id = 251
// module chunks = 0